module.exports = __webpack_public_path__ + "img/laboratorio5_4-3.230ff720.jpg";